import styled from 'styled-components';
import { styleVariables } from '../../../common/constants';

const SearchRootElement = styled.div`
    width: 100%;
    // padding-top: 24px;
    margin-bottom: 60px;
    @media (max-width: 767px) {
        margin-bottom: 36px;
    }
    .search-title {
        font-size: 18px;
        color: ${styleVariables.inkOnBackground};
        font-weight: ${styleVariables.primitivesFontWeights.stout};
        margin-bottom: 10px;
    }
    .search-field {
        width: 320px;
        @media (max-width: 568px) {
            width: 100%;
        }
        .MuiInputBase-formControl {
            border-radius: 4px;
            box-shadow: none;
            border: none;
            background: rgba(0, 0, 0, 0.04);
            input {
                ::-webkit-input-placeholder {
                    color: rgba(0, 0, 0, 0.6);
                    opacity: 1;
                }
                ::-moz-placeholder {
                    color: rgba(0, 0, 0, 0.6);
                    opacity: 1;
                }
                ::-ms-input-placeholder {
                    color: rgba(0, 0, 0, 0.6);
                    opacity: 1;
                }
            }
            input[type='search']::-webkit-search-cancel-button {
                display: none;
            }
            &::before {
                border: none;
            }
            &::after {
                border: none;
            }
            &:hover {
                &::before {
                    border: none;
                    box-shadow: none;
                }
                &::after {
                    border: none;
                }
            }
            &:focus {
                &::before {
                    box-shadow: none;
                }
            }
            &.Mui-focused:before {
                box-shadow: none;
            }
        }
        svg {
            width: 22px;
            color: ${styleVariables.primitivesColor.primary.black};
            margin-left: 5px;
            margin-right: 5px;
        }
    }
`;
export default SearchRootElement;
